import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const userService = {
  getAllUsers: async (filters = {}) => {
    const response = await axios.get(`${API_BASE_URL}/admin/users`, {
      params: filters,
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getUserById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/admin/users/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  updateUserStatus: async (id, statusData) => {
    const response = await axios.put(
      `${API_BASE_URL}/admin/users/${id}/status`,
      statusData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export default userService;

